// promise login
import { Promise } from 'es6-promise';
// @ts-ignore
import Account from '@byted/ecom-mobile-lib/components/login';
import { get, post } from 'libs/request';
import { API_EC, API_ORIGIN, API_USER } from 'config/host';

function login(config = {}) {
    return new Promise((resolve, reject) => {
        let dismissModal = function () {
            document.body.removeEventListener('loginSuccess', resolveHandler);
            document.body.removeEventListener('dismissModal', rejectHandler);
            account.done();
        };
        const account = new Account({
            modal: true,
            agreementHtml:
                '我已阅读并同意<a href="https://www.toutiao.com/user_agreement/" target="_blank">“用户协议”</a>和“<a href="https://www.toutiao.com/privacy_protection/" target="_blank">隐私政策”</a>',
            // formData: false,
            // urlOrigin: 'https://haohuo.jinritemai.com',
            ...config
        });
        const resolveHandler = function resolveHandler(e: any) {
            dismissModal();
            resolve(e.detail);
        };
        const rejectHandler = function rejectHandler() {
            dismissModal();
            reject(new Error('关闭登录'));
        };
        document.body.addEventListener('loginSuccess', resolveHandler);
        document.body.addEventListener('dismissModal', rejectHandler);
    });
}
export function outLogin() {
    return login({ urlOrigin: 'https://haohuo.jinritemai.com' }).then((e: any) => {
        const loginData = e && e.data;
        const sessionKey = loginData && loginData.session_key;
        if (sessionKey) {
            return Promise.all([
                post(`${API_ORIGIN}/common/recheckSession`, { sess: sessionKey }),
                post(`${API_EC}/common/recheckSession`, { sess: sessionKey }),
                post(`${API_USER}/common/recheckSession`, { sess: sessionKey })
            ]).then(() => {
                return 'success';
            });
        }
        return '';
    });
}
